module.exports = __webpack_public_path__ + "static/media/cross-circle-red.d66411aa.png";